import React from "react";
import {
  Box,
  Typography,
  Divider,
  Stack,
  Link,
  Container,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";

import FooterBottom from "./FooterBottom";

import { VM_Colors } from "../../Styles/VMStyles";

const FooterSection = () => {
  return (
    <Box component="footer" sx={{ bgcolor: "#000", color: "#fff" }}>
      {/* ================= MAIN FOOTER ================= */}
      <Container
        maxWidth="lg"
        sx={{
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Box sx={{ py: { xs: 2, md: 4 } }}>
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={{ xs: 4, md: 8 }}
            alignItems="flex-start"
          >
            {/* ================= LEFT ================= */}
            <Stack spacing={3} flex={1}>
              {/* Logo */}
              <Box
                component="img"
                src={'static/vm_logo_white_text_bg.png'}
                alt="Venue Manager"
                sx={{ height: 38 , width: '150px'}}
              />

              {/* CONTACT INFO */}
              <Stack
                direction={{ xs: "column", lg: "row" }}   // ✅ KEY FIX
                spacing={{ xs: 3, lg: 6 }}
                alignItems="flex-start"
              >
                {/* Address */}
                <Stack spacing={1} sx={{ minWidth: 220 }}>
                  <Typography variant="h3" fontWeight={600} color={VM_Colors.white}>
                    Address
                  </Typography>
                  <Typography sx={{ color: '#64748b', lineHeight: 1.7 }}>
                  GAAMI WORKS CONSULTING PRIVATE LIMITED
                  <br />
                  402, 7-1-50, Siddharatha Apartments,
                  <br />
                  Dharam Karam Road,
                  <br />
                  Hyderabad, Telangana 500038,
                  <br />
                  India
                </Typography>
                </Stack>

                {/* Phone */}
                <Stack spacing={1} sx={{ minWidth: 180 }}>
                  <Typography variant="h3" fontWeight={600} color={VM_Colors.white}>
                    Phone
                  </Typography>
                  {["+91 88975 45660"].map((num, i) => (
                    <Stack
                      key={i}
                      direction="row"
                      spacing={1}
                      alignItems="center"
                    >
                      <PhoneIcon fontSize="small" />
                      <Link
                        href={`tel:${num}`}
                        color="inherit"
                        underline="hover"
                        sx={{ opacity: 0.85 }}
                      >
                        {num}
                      </Link>
                    </Stack>
                  ))}
                </Stack>

                {/* Email */}
                <Stack spacing={1} sx={{ minWidth: 220 }}>
                  <Typography variant="h3" fontWeight={600} color={VM_Colors.white}>
                    Email
                  </Typography>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <EmailIcon fontSize="small" />
                    <Link
                      href="mailto:info@venuemanagercrm.com"
                      color="inherit"
                      underline="hover"
                      sx={{ opacity: 0.85 }}
                    >
                      info@venuemanagercrm.com
                    </Link>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>

            {/* ================= DESKTOP DIVIDER ================= */}
            <Divider
              orientation="vertical"
              flexItem
              sx={{
                display: { xs: "none", md: "block" },
                bgcolor: "rgba(255,255,255,0.25)",
              }}
            />

            {/* ================= RIGHT ================= */}
            <Stack
              spacing={2}
              alignItems={{ xs: "flex-start", md: "center" }}
              sx={{ width: "100%" }}
            >
              {/* <Typography variant="h4" fontWeight={600} color={VM_Colors.white}>
                Download Our App
              </Typography> */}

              <Box
                component="a"
                href="https://play.google.com/store/apps/details?id=com.venuemanager.app&hl=en_IN"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Box component="img" src={'/static/google_store.jpg'} sx={{ width: 150 }} />
              </Box>

              <Box
                component="a"
                href="https://apps.apple.com/in/app/venue-manager-banquet-hall-crm/id6737769622"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Box component="img" src={'/static/app_store.jpg'} sx={{ width: 150 }} />
              </Box>
            </Stack>
          </Stack>
        </Box>
      </Container>

      {/* ================= BOTTOM ================= */}
      <Divider sx={{ bgcolor: "rgba(255,255,255,0.2)" }} />
      <FooterBottom />
    </Box>
  );
};

export default FooterSection;
